// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackPopover-cls1_6Un","cls2":"FeedbackPopover-cls2_i1Y FeedbackPopover-cls1_6Un"};